import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicLayoutComponent } from './basic-layout.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { navConfig } from './navigation.config';
import { NAV_CONFIG } from '../shared/core/models/navigation-config.interface';
import { RouterModule } from '@angular/router';
import { IconsModule } from '../shared/core/modules/icons.module';
import { XosButtonComponent } from '../shared/core/core-components/xos-button/xos-button.component';
import { ScrollingDirective } from './directives/scrolling.directive';
import { FooterComponent } from './components/footer/footer.component';
import { XosCompanyLogoComponent } from '../shared/core/core-components/xos-company-logo/xos-company-logo.component';
import { StoreModule } from '@ngrx/store';
import { basicLayoutFeature } from './state/reducers';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ImagesCarouselComponent } from '../shared/components/images-carousel/images-carousel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalContentComponent } from './components/modal-content/modal-content.component';
import { EffectsModule } from '@ngrx/effects';
import { BasicLayoutEffects } from './state/effects';
import { ToastyComponent } from '../shared/components/toasty/toasty.component';
import { XosLoaderComponent } from '../shared/core/core-components/xos-loader/xos-loader.component';



@NgModule({
  declarations: [
    BasicLayoutComponent,
    NavBarComponent,
    ScrollingDirective,
    FooterComponent,
    SideBarComponent,
    ModalContentComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    XosButtonComponent,
    XosCompanyLogoComponent,
    ImagesCarouselComponent,
    XosLoaderComponent,
    ToastyComponent,
    StoreModule.forFeature(basicLayoutFeature),
    EffectsModule.forFeature([BasicLayoutEffects])
  ],
  providers: [
    {
      provide: NAV_CONFIG,
      useValue: navConfig
    }
  ]
})
export class LayoutModule { }
